import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessTimeComponent } from './access-time.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { ParsedDateTimeModule } from '../../../libs/ui/pipes/parsed-date-time/parsed-date-time.module';

@NgModule({
  declarations: [AccessTimeComponent],
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatIconModule,
    FormsModule,
    MatButtonModule,
    SharedLayoutModule,
    WithTooltipModule,
    TranslateModule,
    ParsedDateTimeModule,
  ],
  exports: [AccessTimeComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],

})
export class AccessTimeModule {}
